import i18n from '@/i18n/config'

export function getLocale(): string {
  const lng = i18n.language || 'ar'
  if (lng === 'ar' || lng === 'ur') return 'ar-EG'
  if (lng === 'fr') return 'fr-FR'
  if (lng === 'tr') return 'tr-TR'
  if (lng === 'ms') return 'ms-MY'
  return 'en-US'
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(getLocale(), options).format(value)
}

export function formatCurrency(value: number, currency: string = 'EGP'): string {
  return new Intl.NumberFormat(getLocale(), { style: 'currency', currency, maximumFractionDigits: 2 }).format(value)
}

export function formatDate(date: Date, options?: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(getLocale(), options ?? { year: 'numeric', month: 'short', day: 'numeric' }).format(date)
}

export function formatDateTime(date: Date, options?: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(getLocale(), options ?? { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date)
}


